// Contextual affiliate offers. Each offer is shown only when it's genuinely
// relevant to what the user is looking at, is clearly labeled "Sponsored", and
// is dismissible. Revenue links here NEVER influence the price data VetBill
// shows — that separation is the whole point of the site.
//
// TO GO LIVE: sign up for the affiliate programs, paste your tracked links into
// `url` below, and set AFFILIATE_ENABLED = true in featureFlags.js.

export const OFFERS = {
  insurance: {
    id: 'insurance',
    icon: '🛡️',
    headline: 'A bill like this is what pet insurance is for',
    body: 'Comparing plans now can save you a lot on the next surgery or emergency.',
    cta: 'Compare pet insurance',
    url: 'https://example.com/pet-insurance?ref=vetbill', // TODO: real affiliate link
  },
  pharmacy: {
    id: 'pharmacy',
    icon: '💊',
    headline: 'Filling a prescription?',
    body: 'The same medication is often cheaper from an online pet pharmacy.',
    cta: 'Compare medication prices',
    url: 'https://example.com/pet-pharmacy?ref=vetbill', // TODO: real affiliate link
  },
};

const BIG_TICKET_CATEGORIES = new Set([
  'Surgery',
  'Hospitalization',
  'Anesthesia / Sedation',
  'Emergency / Urgent Care',
  'Dental',
]);

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

const serviceAmount = (service) =>
  toNumber(service?.totalCost)
  ?? toNumber(service?.normalized?.total)
  ?? toNumber(service?.highCost)
  ?? toNumber(service?.normalized?.highEstimate)
  ?? toNumber(service?.unitCost)
  ?? 0;

const serviceCategory = (service) =>
  service?.standardization?.category || service?.category || '';

// Pick the single most relevant offer for a bill/estimate, or null when nothing
// fits (we'd rather show nothing than force an ad). Insurance wins for
// estimates and big-ticket care; pharmacy for medication lines.
export const pickOfferForBill = (bill) => {
  if (!bill) return null;
  const services = Array.isArray(bill.services) ? bill.services : [];
  const isEstimate = String(bill.documentType || '').toLowerCase() === 'estimate';

  const maxAmount = services.reduce((max, s) => Math.max(max, serviceAmount(s)), 0);
  const hasBigTicket = maxAmount >= 500 || services.some(s => BIG_TICKET_CATEGORIES.has(serviceCategory(s)));
  const hasMedication = services.some(s => serviceCategory(s) === 'Medication');

  if (isEstimate || hasBigTicket) return OFFERS.insurance;
  if (hasMedication) return OFFERS.pharmacy;
  return null;
};
